import gql from 'graphql-tag';
import { parseToMutationRequest } from 'utils/utils';
import jobScheduleNS from './constants/jobScheduleNS';
import { getUserId } from '../../localStorages';

export default data => {
  const newData = data;
  newData.userId = getUserId() || newData.userId || null;
  const dataCreate = parseToMutationRequest(newData, jobScheduleNS);
  const modifyJobSchedule = `modifyJobSchedule(input: ${dataCreate})`;
  return gql`
  mutation {
    ${modifyJobSchedule} {
      id
      status
      scheduleDate
      userId
      resetAllowed
      jobScheduleList {
        index
        jobId
        predJobId
        nextJobId
        name
        notes
        userId
        scheduleTime
        type
        scheduleType
        status
        count
        countSuccess
        countError
      }   
    }
  }
`;
};
